<template>
  <navroot />
  <div class="scroll-box fadeIn" :style="{ backgroundImage: 'url(' + pageContent?.background_image + ')' }">
    <div class="class-list-box">
      <div class="join-box">
        <span class="title-text">{{ textList.joinText }}</span>
        <a-input-search size="large" class="join-input" v-model:value="keyword" placeholder="输入邀请码快速加入训练"
          @search="onSearch" />
      </div>
      <div class="list-box">
        <span class="title-text">{{ textList.titleText }}</span>
        <a-spin class="list-spin" wrapperClassName="spin-style" v-if="loading" tip="加载中..."></a-spin>
        <div class="class-list">
          <div class="class-item fadeIn" v-for="item in classList" @click="routeClass(item)">
            <i class="item-cover" :style="{ backgroundImage: 'url(' + item.CoverUrl + ')' }"></i>
            <div class="item-info">
              <a-tooltip placement="topLeft">
                <template #title>{{ item.ClassName }}</template>
                <div class="item-title">{{ item.ClassName }}</div>
              </a-tooltip>
              <div class="item-time">创建：{{ item.CreateTime }}</div>
            </div>
            <div class="item-bottom">
              <div class="item-int">
                <svg class="icon-svg int-icon">
                  <use xlink:href="#icon-shuji" />
                </svg>
                <span>{{ item.codeCount || 0 }}个环节</span>
              </div>
              <a-button size="small" class="enter-button" type="primary" :style="{ color: theme_color }">进入</a-button>
            </div>
          </div>
          <a-empty v-if="!loading && classList.length == 0" description="未加入任何训练" />
        </div>
      </div>
      <!-- 加入训练 -->
      <div class="new-popupbox fadeIn" v-if="joinClass">
        <div class="hanlder-box">
          <svg class="icon-svg popup-close" @click="joinClass = null">
            <use xlink:href="#icon-guanbi" />
          </svg>
        </div>
        <a-spin class="loading" v-if="loadJoinClass" />
        <div class="class-item new-class-item fadeIn" v-if="joinClass" :style="{ backgroundColor: theme_color }">
          <i class="item-cover" :style="{ backgroundImage: 'url(' + joinClass.CoverUrl + ')' }"></i>
          <div class="item-info">
            <div class="item-title">{{ joinClass.ClassName }}</div>
            <div class="item-time">创建：{{ joinClass.CreateTime }}</div>
          </div>
          <div class="item-bottom">
            <div class="item-int">
              <svg class="icon-svg int-icon">
                <use xlink:href="#icon-shuji" />
              </svg>
              <span>{{ joinClass.codeCount || 0 }}个环节</span>
            </div>
            <a-button class="enter-button" @click="joining" :loading="isJoining"
              :style="{ color: theme_color }">加入训练</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navroot from "../nav/nav.vue";
import { LoadingOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    navroot, LoadingOutlined
  },
  name: "login",
  data() {
    return {
      userGuid: '',
      theme_color: '',
      platformType: '',
      platformGuid: '',

      loading: true,
      keyword: null,
      classList: [],

      textList: {
        joinText: '加入训练',
        titleText: '全部训练'
      },

      loadJoinClass: false,
      joinClass: null,
      isSearching: false,
      isJoining: false,
      pageContent: null
    }
  },
  async mounted() {
    let { userInfo, platform } = this.$store.state;
    if (!userInfo) return;

    this.userGuid = userInfo.PK_UserGuid;
    this.pageContent = platform.page_content['class_list'];
    this.theme_color = platform.pageConfig.theme_color;
    this.platformGuid = platform.PK_PlatformGuid;
    this.platformType = platform.Type;

    this.classList = await this.$api.unifydata.getClassOfUser(this.platformType).then(res => res.data || []);

    let textList = this.textList;
    if (platform.Type == 'sz') {
      textList.joinText = '搜索教材';
      textList.titleText = '加入教材';
    }

    this.loading = false;
  },
  methods: {
    //跳转班级
    routeClass(item) {
      this.$router.push({ path: `./list/${item.PK_ClassGuid}` })
    },
    //搜索
    async onSearch() {
      if (this.isSearching) return;
      this.isSearching = true;
      let keyword = this.keyword;
      if (keyword) this.keyword = keyword.trim();
      let res = await this.$api.unifydata.classCode({ code: this.keyword });
      this.isSearching = false;
      if (!res.data) return this.$message.warning('邀请码不正确');
      let data = res.data;
      if (data.FK_PlatformGuid != this.platformGuid) return this.$message.warning('该班级不属于此平台，请确认班级绑定平台是否相符');

      let existClass = this.classList.find(item => item.PK_ClassGuid == data.PK_ClassGuid)
      if (existClass) return this.$message.warning('您已加入该班级，请勿重复加入');
      this.joinClass = data;
    },
    //加入班级中
    async joining() {
      if (this.isJoining) return;
      this.isJoining = true;
      let res = await this.$api.unifydata.joinClass({ userGuid: this.userGuid, code: this.keyword, platformGuid: this.platformGuid });
      this.isJoining = false;
      if (res.statusCode != 200) return this.$message.warning(res.message);
      this.joinClass = null;
      this.$message.success('加入训练成功');
      this.getClassList();
    },
    //重新获取班级数据
    async getClassList() {
      this.loading = true;
      this.classList = [];
      let classList = await this.$api.unifydata.getClassOfUser(this.platformType).then(res => res.data || []);
      this.$store.commit('classList', classList);
      this.classList = classList;
      this.loading = false;
    },
  },
}
</script>

<style scoped lang="scss">
@import "./class-list.scss";
</style>